import {
  createPaymentsResourceGuard,
  deletePaymentsResourceGuard,
  editPaymentsResourceGuard,
  paymentsCollectionGuard,
  paymentsResourceGuard,
} from './_api/payments';

export const resourcePaymentsRoutes = paymentsResourceGuard;
export const deletePaymentsRoutes = deletePaymentsResourceGuard;
export const createPaymentsRoutes = createPaymentsResourceGuard;
export const collectionPaymentsRoutes = paymentsCollectionGuard;
export const editPaymentsRoutes = editPaymentsResourceGuard;

export const routeGuard = paymentsCollectionGuard;
